import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    // Check if there's a saved end time in localStorage
    const savedEndTime = localStorage.getItem('hockeyOfferEndTime');
    let endTime: number;
    if (savedEndTime && parseInt(savedEndTime) > Date.now()) {
      endTime = parseInt(savedEndTime);
    } else {
      // Set new end time to 23:59:59 from now
      endTime = Date.now() + 23 * 60 * 60 * 1000 + 59 * 60 * 1000 + 59 * 1000;
      localStorage.setItem('hockeyOfferEndTime', endTime.toString());
    }
    const timer = setInterval(() => {
      const now = Date.now();
      const difference = endTime - now;
      if (difference <= 0) {
        // Reset timer
        const newEndTime = Date.now() + 23 * 60 * 60 * 1000 + 59 * 60 * 1000 + 59 * 1000;
        localStorage.setItem('hockeyOfferEndTime', newEndTime.toString());
        endTime = newEndTime;
      } else {
        setTimeLeft({
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex flex-col items-center justify-center space-y-2" data-id="element-43">
      <p className="text-brand-cream font-medium uppercase tracking-wider text-sm" data-id="element-44">
        La oferta termina en:
      </p>
      <div className="flex gap-4 text-center" data-id="element-45">
        <div className="bg-brand-card border border-brand-accent/30 rounded-lg p-3 min-w-[70px] shadow-lg shadow-brand-accent/10" data-id="element-46">
          <span className="font-display text-3xl text-brand-accent block" data-id="element-47">
            {formatNumber(timeLeft.hours)}
          </span>
          <span className="text-[10px] text-brand-cream/70 uppercase font-bold" data-id="element-48">
            Horas
          </span>
        </div>
        <div className="text-brand-accent font-display text-3xl mt-2" data-id="element-49">:</div>
        <div className="bg-brand-card border border-brand-accent/30 rounded-lg p-3 min-w-[70px] shadow-lg shadow-brand-accent/10" data-id="element-50">
          <span className="font-display text-3xl text-brand-accent block" data-id="element-51">
            {formatNumber(timeLeft.minutes)}
          </span>
          <span className="text-[10px] text-brand-cream/70 uppercase font-bold" data-id="element-52">
            Minutos
          </span>
        </div>
        <div className="text-brand-accent font-display text-3xl mt-2" data-id="element-53">:</div>
        <div className="bg-brand-card border border-brand-accent/30 rounded-lg p-3 min-w-[70px] shadow-lg shadow-brand-accent/10" data-id="element-54">
          <span className="font-display text-3xl text-brand-accent block" data-id="element-55">
            {formatNumber(timeLeft.seconds)}
          </span>
          <span className="text-[10px] text-brand-cream/70 uppercase font-bold" data-id="element-56">
            Segundos
          </span>
        </div>
      </div>
    </div>;
}